"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return Script;
    }
});
const _Noco = /*#__PURE__*/ _interop_require_default(require("~/Noco"));
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
let Script = class Script {
    static async get(_context, _param1, _ncMeta = _Noco.default.ncMeta) {
        return null;
    }
    static async list(_context, _param1, _ncMeta = _Noco.default.ncMeta) {
        return [];
    }
    static async delete(_context, _param1, _ncMeta = _Noco.default.ncMeta) {
        return true;
    }
    static async update(_context, _param1, _param2, _ncMeta = _Noco.default.ncMeta) {
        return {};
    }
    static async insert(_context, _param1, _param2, _ncMeta = _Noco.default.ncMeta) {
        return {};
    }
    constructor(_unknown){
        Object.assign(this, _unknown);
    }
};
